import ExpensesRegisterTable from '../Components/Omnichannel/Expenses/ExpensesRegisterTable'
import Kiosk from '../Pages/Kiosk/Kiosk'
import SubRuleDetail from '../Pages/Omnichannel/Components/SubRuleDetail'
import RuleDetail from '../Pages/Omnichannel/Components/RuleDetail'
import Omnichannel from '../Pages/Omnichannel/Omnichannel'
import OmnichannelSettings from '../Pages/Settings/Components/OmnichannelSettings'
import Settings from '../Pages/Settings/Settings'
import Utility from '../Pages/Utility/Utility'
import { UiCodePricesOmnichannel, UiCodeSettings, UiCodeUtility } from './Configuration'
import RenderByProfileOptionWrapper from '../Components/Generic/RenderByProfileOptionWrapper'
import { Login } from '../Pages/Login/Login'
import PrivatePage from '../Pages/PrivatePage'
import Home from '../Pages/Home'

const CLIENT_PAGES = {
  Omnichannel: {
    path: 'omnichannel',
    children: {
      Rule: {
        path: 'rule',
      },
      Subrule: {
        path: 'subrule',
      },
      Channels: {
        path: 'channel',
      },
      Expenses: {
        path: 'expenses',
      },
    },
  },
  Settings: {
    path: 'settings',
  },
  Utility: {
    path: 'utility',
  },
}

const CLIENT_PATH_PARAMETERS = {
  Id: '/:id',
}

export const CLIENT_PAGES_PATH = {
  Login: '/login',
  //DIWA
  Homepage: '/',
  //OMNICHANNEL
  Omnichannel: `/${CLIENT_PAGES.Omnichannel.path}`,
  Rule: `/${CLIENT_PAGES.Omnichannel.path}/${CLIENT_PAGES.Omnichannel.children.Rule.path + CLIENT_PATH_PARAMETERS.Id}`,
  Subrule: `/${CLIENT_PAGES.Omnichannel.path}/${
    CLIENT_PAGES.Omnichannel.children.Subrule.path + CLIENT_PATH_PARAMETERS.Id
  }`,
  ChannelSettings: `/${CLIENT_PAGES.Omnichannel.path}/${CLIENT_PAGES.Omnichannel.children.Channels.path}`,
  Expenses: `/${CLIENT_PAGES.Omnichannel.path}/${CLIENT_PAGES.Omnichannel.children.Expenses.path}`,
  // UTILITY
  Utility: `/${CLIENT_PAGES.Utility.path}`,
  //SETTINGS
  Settings: `/${CLIENT_PAGES.Settings.path}`,
}

export const CLIENT_ROUTES = [
  {
    path: CLIENT_PAGES_PATH.Login,
    element: <Login />,
  },
  {
    path: CLIENT_PAGES_PATH.Homepage,
    element: <Home />,
    children: [
      {
        index: true,
        element: (
          <PrivatePage>
            <Kiosk />
          </PrivatePage>
        ),
      },
      {
        path: CLIENT_PAGES_PATH.Omnichannel,
        element: (
          <PrivatePage>
            <RenderByProfileOptionWrapper sectionName={UiCodePricesOmnichannel}>
              <Omnichannel />
            </RenderByProfileOptionWrapper>
          </PrivatePage>
        ),
        children: [
          {
            path: CLIENT_PAGES_PATH.Rule,
            element: (
              <PrivatePage>
                <RuleDetail />
              </PrivatePage>
            ),
          },
          {
            path: CLIENT_PAGES_PATH.Subrule,
            element: (
              <PrivatePage>
                <SubRuleDetail />
              </PrivatePage>
            ),
          },
          {
            path: CLIENT_PAGES_PATH.ChannelSettings,
            element: (
              <PrivatePage>
                <RenderByProfileOptionWrapper sectionName={UiCodePricesOmnichannel}>
                  <OmnichannelSettings />
                </RenderByProfileOptionWrapper>
              </PrivatePage>
            ),
          },
          {
            path: CLIENT_PAGES_PATH.Expenses,
            element: (
              <PrivatePage>
                <ExpensesRegisterTable />
              </PrivatePage>
            ),
          },
        ],
      },
      {
        path: CLIENT_PAGES_PATH.Settings,
        element: (
          <PrivatePage>
            <RenderByProfileOptionWrapper sectionName={UiCodeSettings}>{<Settings />}</RenderByProfileOptionWrapper>
          </PrivatePage>
        ),
      },
      {
        path: CLIENT_PAGES_PATH.Utility,
        element: (
          <PrivatePage>
            <RenderByProfileOptionWrapper sectionName={UiCodeUtility}>{<Utility />}</RenderByProfileOptionWrapper>
          </PrivatePage>
        ),
      },
    ],
  },
]
